import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { StyledIndicator } from "./indicator.styles";
export function Indicator({ currentPage, perPageItems, totalItems, pagesFilterLabel, }) {
    const total = currentPage * perPageItems;
    return (_jsxs(StyledIndicator, { children: [_jsxs("span", { children: [total - perPageItems + 1, "-", total <= totalItems ? total : totalItems] }), _jsx("span", { children: "of" }), _jsxs("span", { children: [totalItems, " ", pagesFilterLabel] })] }));
}
